var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconopenMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.425,
    viewBox: "0 0 20 17.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-menu",
    "data-name": "Icon open-menu",
    d: "M0,0V2.5H20V0ZM0,7.425v2.5H20v-2.5Zm0,7.5v2.5H20v-2.5Z",
    fill: "#4671a4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconopenMenu);
export default __webpack_public_path__ + "static/media/Icon open-menu.c2819bf9c4008875ae689a310a56a848.svg";
export { ForwardRef as ReactComponent };